import React, { useEffect, useState } from "react";
import toast from "react-hot-toast";
import { adminDashboardDetailsApi } from "../../../utils/ApiEndpointFunctions";
import Spinwheel from "../../common/Spinwheel";
// import DashboardCommonCard from "../../common/Cards/DashboardCommonCard";
// import TopPerformerCard from "../../common/Cards/TopPerformerCard";
import { useAdminContext } from "../../../context/adminContext";
import { useNavigate } from "react-router-dom";
import InfoPanel from "./components/InfoPanel";
import DashboardCommonCard from "./components/DashboardComonCard";
import { formatNumber } from "../../../utils/HelperFuncitons";
import TopPerformerCard from "./components/TopPerformerCard";
import PaymentChart from "./components/PaymentChart";

export default function Dashboard() {
  const [loader, setLoader] = useState(true)
  const [details, setDetails] = useState({})
  const { setAdminDetail, adminDetail } = useAdminContext();
  const navigate = useNavigate()

  const getDashboardDetails = async () => {
    try {
      setLoader(true);
      const res = await adminDashboardDetailsApi();
      setDetails(res?.data?.data);
      setLoader(false);
    } catch (error) {
      toast.error(error.message || "Something went wrong");
      setLoader(false);
    }
  }

  useEffect(() => {
    if (adminDetail?.role === "superAdmin") {
      getDashboardDetails();
    } else {
      navigate("/partners?type=all")
    }

  }, [adminDetail?.role])


  return (
    <>
      <div className="main-content">

        <div className="container-fluid">
          {
            loader ? <Spinwheel /> :
              <>
                <div className="mt-4 g-4">

                  {/* first row */}

                  <div className="custom-row">
                    {/* Rides (Trips) Section */}
                    <InfoPanel title="Rides(trips)" variant="primary" className="col-12 col-md-6">
                      <div className="row">
                        <div className="col-12 col-md-4">
                          <div className="col-12">
                            <DashboardCommonCard title={"Today"} value={details?.rideDetails?.[0]?.rideBookingThisDay || 0} icon={<i class="bi bi-activity"></i>} />
                            <DashboardCommonCard title={"This Week"} value={details?.rideDetails?.[0]?.rideBookingThisWeek || 0} icon={<i class="bi bi-activity"></i>} />
                            <DashboardCommonCard title={"This Month"} value={details?.rideDetails?.[0]?.rideBookingThisMonth || 0} icon={<i class="bi bi-activity"></i>} />
                          </div>
                        </div>
                        <div className="col-12 col-md-4">
                          <div className="col-12">
                            <DashboardCommonCard title={"Total Rides Requested"} value={details?.rideDetails?.[0]?.rideBookingTotal || 0} icon={<i class="bi bi-activity"></i>} />
                            <DashboardCommonCard title={"In-Progress"} value={details?.rideDetails?.[0]?.inProgressRides || 0} icon={<i class="bi bi-activity"></i>} />
                            <DashboardCommonCard title={"Completed"} value={details?.rideDetails?.[0]?.completedRides || 0} icon={<i class="bi bi-activity"></i>} />
                          </div>
                        </div>
                        <div className="col-12 col-md-4">
                          <div className="col-12">
                            <DashboardCommonCard title={"Cancelled"} value={details?.rideDetails?.[0]?.cancelledRides || 0} icon={<i class="bi bi-activity"></i>} />
                            <DashboardCommonCard title={"Cancelled"} isValueBold={false} value={`${details?.rideDetails?.[0]?.cancelledRides || 0} (Riders: ${details?.rideDetails?.[0]?.userCancelledRide || 0} | Drivers: ${details?.rideDetails?.[0]?.driverCancelledRide || 0})`} icon={<i class="bi bi-activity"></i>} />
                            <DashboardCommonCard title={"Expired Requests"} value={details?.rideDetails?.[0]?.expired || 0} icon={<i class="bi bi-activity"></i>} />
                          </div>
                        </div>
                      </div>
                    </InfoPanel>

                    {/* Driver Section */}
                    <InfoPanel title="Drivers" variant="primary" className="col-12 col-md-6">
                      <div className="row">
                        <div className="col-12 col-md-4">
                          <div className="col-12 g-4">
                            <DashboardCommonCard title={"Total Drivers"} value={details?.driverDetails?.[0]?.totalDriver || 0} icon={<i class="bi bi-activity"></i>} />
                            <DashboardCommonCard title={"Verified"} value={details?.driverDetails?.[0]?.approvedDriver || 0} icon={<i class="bi bi-activity"></i>} />
                            <DashboardCommonCard title={"Unverified"} value={details?.driverDetails?.[0]?.rejectedDriver || 0} icon={<i class="bi bi-activity"></i>} />
                          </div>
                        </div>
                        <div className="col-12 col-md-4">
                          <div className="col-12">
                            <DashboardCommonCard title={"Online"} value={details?.driverDetails?.[0]?.OnlineDriver || 0} icon={<i class="bi bi-activity"></i>} />
                            <DashboardCommonCard title={"Offline"} value={`${details?.driverDetails?.[0]?.OfflineDriver || 0}`} icon={<i class="bi bi-activity"></i>} />
                            <DashboardCommonCard title={"On Subscription"} value={details?.driverDetails?.[0]?.OnSubscriptionDriver || 0} icon={<i class="bi bi-activity"></i>} />
                          </div>
                        </div>
                        <div className="col-12 col-md-4">
                          <div className="col-12">
                            <DashboardCommonCard title={"On Commission"} value={details?.driverDetails?.[0]?.OnCommissionDriver || 0} icon={<i class="bi bi-activity"></i>} />
                          </div>
                        </div>
                      </div>
                    </InfoPanel>
                  </div>





                  {/* 2nd row */}
                  <div className="custom-row">
                    {/* Payment Section */}
                    <div className="col-12 col-md-6 rounded-3 bg-white shadow-sm mb-3 p-3">
                      <PaymentChart />
                    </div>
                    {/* Revenue Section */}
                    <InfoPanel title="Revenue" variant="primary" className="col-12 col-md-6">
                      <div className="row">
                        <div className="col-12 col-md-4">
                          <div className="col-12 g-4">
                            <DashboardCommonCard title={"Ride Hailing"} value={0} />
                            <DashboardCommonCard title={"Fleet Owner"} value={0} />
                            <DashboardCommonCard title={"Car Rental"} value={0} />
                          </div>
                        </div>
                        <div className="col-12 col-md-4">
                          <div className="col-12">
                            <DashboardCommonCard title={"Commission"} value={0} />
                            <DashboardCommonCard title={"Bus Operators"} value={0} />
                          </div>
                        </div>
                        <div className="col-12 col-md-4">
                          <div className="col-12">
                            <DashboardCommonCard title={"Subscription"} value={0} />
                            <DashboardCommonCard title={"Restaurant"} value={0} />
                          </div>
                        </div>
                      </div>
                    </InfoPanel>
                  </div>



                  {/* 3rd row */}
                  <div className="custom-grid-2-1-2-row">
                    {/* top performers section */}
                    <InfoPanel title="Top Performing Drivers" variant="primary">
                      <div className="custom-row-flex" style={{ gap: '0.5rem' }}>
                        <InfoPanel title="Weekly" variant="light" className="col-12 col-md-6">
                          {details?.topPerformarDriver?.filter(ele => ele?.PerformancePeriod?.toLowerCase() == "weekly")?.sort((a, b) => Number(a?.rank) - Number(b?.rank))?.map(ele => <>
                            <TopPerformerCard title={ele?.driverName} firstValue={`Trips: ${ele?.totalTrips}`} secondValue={` Amount: ${formatNumber(ele?.totalEarnings)}`}icon={ele?.rank} />
                          </>)}
                        </InfoPanel>
                        <InfoPanel title="Monthly" variant="light" className="col-12 col-md-6">
                          {details?.topPerformarDriver?.filter(ele => ele?.PerformancePeriod?.toLowerCase() == "monthly")?.sort((a, b) => Number(a?.rank) - Number(b?.rank))?.map(ele => <>
                            <TopPerformerCard title={ele?.driverName} firstValue={`Trips: ${ele?.totalTrips}`} secondValue={` Amount: ${formatNumber(ele?.totalEarnings)}`} icon={ele?.rank} />
                          </>)}
                        </InfoPanel>
                      </div>

                    </InfoPanel>
                    {/* fleet owners Section */}
                    <InfoPanel title="Fleet Owners" variant="primary" >
                      <div className="row">
                        <div className="col-12">
                          <DashboardCommonCard title={"Total Fleet owners"} value={details?.fleetOwnerDetails?.[0]?.totalFleetOnwers || 0} icon={<i class="bi bi-activity"></i>} />
                          <DashboardCommonCard title={"Total fleet drivers"} value={details?.fleetOwnerDetails?.[0]?.fleetDrivers || 0} icon={<i class="bi bi-activity"></i>} />
                          <DashboardCommonCard title={"Total vehicles"} value={details?.fleetOwnerDetails?.[0]?.fleetVehicle || 0} icon={<i class="bi bi-activity"></i>} />
                        </div>
                      </div>
                    </InfoPanel>
                    {/* bus operators Section */}
                    <InfoPanel title="Bus Operators" variant="primary" >
                      <div className="row">

                      </div>
                    </InfoPanel>

                  </div>


                  {/* rewards/referrals 4th row */}
                  <div className="custom-row">
                    <InfoPanel title={"Rewards/Referrals"} variant="primary" className={"w-100"}>
                      <div className="custom-row-flex">
                        <InfoPanel title="User Rewards" variant="light" className="col-12 col-md-6">
                          <div className="row">
                            <div className="col-4 col">
                              <div className="col-12">
                                <DashboardCommonCard title={"Today"} value={formatNumber(details?.userRewardAndReferral[0]?.dailyrewardAmt)} icon={<i class="bi bi-activity"></i>} />
                                <DashboardCommonCard title={"Weekly"} value={formatNumber(details?.userRewardAndReferral[0]?.weekRewardAmt)} icon={<i class="bi bi-activity"></i>} />
                              </div>
                            </div>
                            <div className="col-12 col-md-4">
                              <div className="col-12">
                                <DashboardCommonCard title={"Monthly"} value={formatNumber(details?.userRewardAndReferral[0]?.montlyRewardAmt)} icon={<i class="bi bi-activity"></i>} />
                                <DashboardCommonCard title={"Total"} value={formatNumber(details?.userRewardAndReferral[0]?.totalRewardAmt)} icon={<i class="bi bi-activity"></i>} />
                              </div>
                            </div>
                            <div className="col-12 col-md-4">
                              <div className="col-12">
                                <DashboardCommonCard title={"Expired"} value={formatNumber(details?.userRewardAndReferral[0]?.expiredRewardAmt)} icon={<i class="bi bi-activity"></i>} />
                              </div>
                            </div>
                          </div>
                        </InfoPanel>
                        <InfoPanel title="User Referrals" variant="light" className="col-12 col-md-6">
                          <div className="row">
                            <div className="col-12 col-md-4">
                              <div className="col-12">
                                <DashboardCommonCard title={"Today"} value={formatNumber(details?.userRewardAndReferral[0]?.dailyReferralAmt)} icon={<i class="bi bi-activity"></i>} />
                                <DashboardCommonCard title={"Weekly"} value={formatNumber(details?.userRewardAndReferral[0]?.weekReferralAmt)} icon={<i class="bi bi-activity"></i>} />
                              </div>
                            </div>
                            <div className="col-12 col-md-4">
                              <div className="col-12">
                                <DashboardCommonCard title={"Monthly"} value={formatNumber(details?.userRewardAndReferral[0]?.montlyReferralAmt)} icon={<i class="bi bi-activity"></i>} />
                                <DashboardCommonCard title={"Total"} value={formatNumber(details?.userRewardAndReferral[0]?.totalReferralAmt)} icon={<i class="bi bi-activity"></i>} />
                              </div>
                            </div>
                            <div className="col-12 col-md-4">
                              <div className="col-12">
                                <DashboardCommonCard title={"Expired"} value={formatNumber(details?.userRewardAndReferral[0]?.expiredReferralAmt)} icon={<i class="bi bi-activity"></i>} />
                              </div>
                            </div>
                          </div>
                        </InfoPanel>
                        <InfoPanel title="Partners Rewards" variant="light" className="col-12 col-md-6">
                          <div className="row">
                            <div className="col-12 col-md-4">
                              <div className="col-12">
                                <DashboardCommonCard title={"Today"} value={formatNumber(details?.partnerRewardAndReferral[0]?.dailyrewardAmt)} icon={<i class="bi bi-activity"></i>} />
                                <DashboardCommonCard title={"Weekly"} value={formatNumber(details?.partnerRewardAndReferral[0]?.weekRewardAmt)} icon={<i class="bi bi-activity"></i>} />
                              </div>
                            </div>
                            <div className="col-12 col-md-4">
                              <div className="col-12">
                                <DashboardCommonCard title={"Monthly"} value={formatNumber(details?.partnerRewardAndReferral[0]?.montlyRewardAmt)} icon={<i class="bi bi-activity"></i>} />
                              </div>
                            </div>
                            <div className="col-12 col-md-4">
                              <div className="col-12">
                                <DashboardCommonCard title={"Total"} value={formatNumber(details?.partnerRewardAndReferral[0]?.totalrewardAmt)} icon={<i class="bi bi-activity"></i>} />
                              </div>
                            </div>
                          </div>
                        </InfoPanel>
                        <InfoPanel title="Partners Referrals" variant="light" className="col-12 col-md-6">
                          <div className="row">
                            <div className="col-12 col-md-4">
                              <div className="col-12">
                                <DashboardCommonCard title={"Today"} value={formatNumber(details?.partnerRewardAndReferral[0]?.dailyReferralAmt)} icon={<i class="bi bi-activity"></i>} />
                                <DashboardCommonCard title={"Weekly"} value={formatNumber(details?.partnerRewardAndReferral[0]?.weekReferralAmt)} icon={<i class="bi bi-activity"></i>} />
                              </div>
                            </div>
                            <div className="col-12 col-md-4">
                              <div className="col-12">
                                <DashboardCommonCard title={"Monthly"} value={formatNumber(details?.partnerRewardAndReferral[0]?.montlyReferralAmt)} icon={<i class="bi bi-activity"></i>} />
                              </div>
                            </div>
                            <div className="col-12 col-md-4">
                              <div className="col-12">
                                <DashboardCommonCard title={"Total"} value={formatNumber(details?.partnerRewardAndReferral[0]?.totalReferralAmt)} icon={<i class="bi bi-activity"></i>} />
                              </div>
                            </div>
                          </div>
                        </InfoPanel>
                      </div>
                    </InfoPanel>
                  </div>

                </div>
              </>
          }


        </div>
      </div>
    </>
  );
}
